import { useState } from "react";
import CustomerService from "../../../../rest/customerService";
import CustomButton from "../../../../components/lib/customButton";

const StudentParentSearch = ({ onSelectParent, onCreateNewParent }) => {
    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleSearch = async () => {
        setLoading(true);
        try {
            const data = await CustomerService.getParentsListByParameter(query);
            setResults(data);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col gap-4">
            
            <div className="flex gap-2">
                <input
                    className="border-2 border-slate-200 shadow-sm rounded-lg w-5/6 h-8 px-4 text-xs md:text-base focus:border-blue-600 focus:outline-none"
                    placeholder="Buscar por nome, login ou email..."
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                />
                <CustomButton
                    className="disabled:opacity-50"
                    buttonType="search"
                    type="button"
                    showIcon={true}
                    text=""
                    onClick={handleSearch}
                />
            </div>

            <ul className="border rounded divide-y min-h-[120px] max-h-64 overflow-y-auto">
                {results.map((parent) => (
                    <li
                        key={parent.id}
                        className="p-3 cursor-pointer hover:bg-gray-100"
                        onClick={() => onSelectParent(parent)}
                    >
                        <p className="font-medium">{parent.name}</p>
                        <p className="text-xs text-gray-500">{parent.email}</p>
                    </li>
                ))}

                {!loading && results.length === 0 && (
                    <li className="p-3 text-sm text-gray-400">
                        Nenhum responsável encontrado
                    </li>
                )}
            </ul>

            {/* SEMPRE VISÍVEL */}
            <CustomButton
                className="disabled:opacity-50"
                buttonType="save"
                type="button"
                showIcon={false}
                text="Cadastrar Responsável"
                onClick={onCreateNewParent}
            />
        </div>
    );
};

export default StudentParentSearch;
